import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter, PreloadAllModules, withComponentInputBinding, withPreloading } from '@angular/router';
import * as Sentry from "@sentry/angular";

import { AppComponent } from './app/app.component';
import { CoreModule } from './app/_services/core.module';
import { SharedModule } from './app/_shared/shared.module';
import { WelcomeModule } from './app/_welcome/welcome.module';
import { environment } from './environments/environment';

// Routes
import { routes } from './app/app-routing.module';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: 'https://64fa376f8c9c4f88a0b7172902fbc4c7@o114829.ingest.sentry.io/252818',
  environment: environment.production ? 'Production' : 'Development',
  release: 'npc@' + environment.version,
  //   new TracingIntegrations.BrowserTracing({
  //     tracingOrigins: ['localhost', 'https://npc.collegeboard.org', 'https://npc.rewiretech.com', /^\//],
  //     routingInstrumentation: instrumentAngularRouting,
  //   }),
  // ],
  // tracesSampleRate: environment.production ? 0.2 : 1,
  ignoreErrors: [
    'top.GLOBALS', // Random plugins/extensions
    'Non-Error exception captured', // An error sent to the Sentry Error Handler not in a native Error Form
    'Non-Error promise rejection captured',
    // Chunk loading (transient network/cache issues)
    /Loading chunk \d+ failed/,
    /Loading chunk .+ failed/,
    'ChunkLoadError',
    // Cross-origin / generic
    'Script error.',
    // Extension-related
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,
  ]
});

// Use bootstrapApplication with importProvidersFrom for Angular 19
// Angular Fire providers are in CoreModule to ensure proper injection context
bootstrapApplication(AppComponent, {
  providers: [
    // Router
    provideZoneChangeDetection(),
    provideRouter(routes, withComponentInputBinding(), withPreloading(PreloadAllModules)),
    provideHttpClient(),
    provideAnimations(),
    // Import all modules - Angular Fire providers are in CoreModule
    importProvidersFrom(
      CoreModule,
      SharedModule,
      WelcomeModule
    )
  ]
})
  .then(() => console.log('Bootstrap success'))
  .catch((err: unknown) => console.error(err));
